<!--wrapper-->
<div *ngIf="showLayout">
  <div *ngIf="isPageLoading" class="page-loader-overlay">
    <div class="loader-container">
      <!-- Animated dots -->
      <div class="dots-wrapper">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
    </div>

      <!-- Loading message -->
      <div class="loader-message">
        <span>{{ loadingMessage }}</span>
        <span class="loading-dots">...</span>
    </div>
    </div>
  </div>
</div>

<div *ngIf="showLayout">
  <div *ngIf="!isPageLoading">
    <div class="wrapper">
      <!--sidebar wrapper -->
      <div
        class="sidebar-wrapper h-100"
        data-simplebar="true"
        *ngIf="isValidUser()"
      >
        <div class="sidebar-header">
          <div style="cursor: pointer">
            <img
              *ngIf="useWhiteLogo"
              routerLink="dashboard"
              src="assets/images/cdwhite.png"
              alt="Logo"
              width="150"
              class="img-fluid"
            />

            <img
              *ngIf="!useWhiteLogo"
              routerLink="dashboard"
              src="assets/images/cdblack.png"
              alt="Logo"
              width="150"
              class="img-fluid"
            />
          </div>
          <div class="toggle-icon ms-auto mt-2" (click)="toggleSidebar()">
            <i class="bx bx-arrow-back"></i>
          </div>
        </div>

        <ul class="metismenu" id="menu" *ngIf="isValidUser()">
          <!-- Dashboard -->
          <li
            routerLinkActive="mm-active"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <a routerLink="/dashboard">
              <div class="parent-icon"><i class="bi bi-house"></i></div>
              <div class="menu-title">
                {{ "APPCOMPONENT.MENU.DASHBOARD" | translate }}
              </div>
            </a>
          </li>

          <li
            routerLinkActive="mm-active"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <a routerLink="/appsdashboard">
              <div class="parent-icon"><i class="bi bi-speedometer2"></i></div>
              <div class="menu-title">
                {{ "APPCOMPONENT.MENU.APPS_DASHBOARD" | translate }}
              </div>
            </a>
          </li>

          <li
            routerLinkActive="mm-active"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <a
              routerLink="/applicationlist"
              class="has-arrow"
              aria-expanded="true"
            >
              <div class="parent-icon"><i class="bi bi-grid"></i></div>
              <div class="menu-title">
                {{ "APPCOMPONENT.MENU.APPLICATIONS" | translate }}
              </div>
            </a>
            <ul class="mm-show">
              <li routerLinkActive="mm-active">
                <a routerLink="/rules">
                  <i class="bx bi bi-terminal-plus"></i>
                  {{ "APPCOMPONENT.MENU.RULES" | translate }}
                </a>
              </li>
              <li routerLinkActive="mm-active">
                <a routerLink="/uiallformlist">
                  <i class="bx bi bi-postcard"></i>
                  {{ "APPCOMPONENT.MENU.UI_FORMS" | translate }}
                </a>
              </li>

              <li routerLinkActive="mm-active">
                <a routerLink="/reportslist">
                  <i class="bx bi bi-clipboard2-data"></i>
                  {{ "APPCOMPONENT.MENU.REPORTS" | translate }}
                </a>
              </li>
            </ul>
          </li>

          <hr />

          <!-- Apps Shop -->
          <li
            routerLinkActive="mm-active"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <a routerLink="/appstore">
              <div class="parent-icon"><i class="bx bx-store"></i></div>
              <div class="menu-title">
                {{ "APPCOMPONENT.MENU.APP_STORE" | translate }}
              </div>
            </a>
          </li>
          <li
            routerLinkActive="mm-active"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <a routerLink="/appbought">
              <div class="parent-icon"><i class="bi bi-bag-check"></i></div>
              <div class="menu-title">
                {{ "APPCOMPONENT.MENU.APP_PURCHASED" | translate }}
              </div>
            </a>
          </li>
          <li
            routerLinkActive="mm-active"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <a routerLink="/appstatus">
              <div class="parent-icon">
                <i class="bi bi-cloud-arrow-down"></i>
              </div>
              <div class="menu-title">
                {{ "APPCOMPONENT.MENU.APP_REQUESTS" | translate }}
              </div>
            </a>
          </li>
          <hr />
          <li
            routerLinkActive="mm-active"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <a routerLink="/appcollaboratorlist">
              <div class="parent-icon">
                <i class="bi bi-person-workspace"></i>
              </div>
              <div class="menu-title">
                {{ "APPCOMPONENT.MENU.DEV_APPS" | translate }}
              </div>
            </a>
          </li>
        </ul>
      </div>
      <!--end sidebar wrapper -->

      <!--start header -->
      <header *ngIf="isValidUser()">
        <div class="topbar d-flex align-items-center">
          <nav class="navbar navbar-expand gap-3">
            <div class="mobile-toggle-menu" (click)="toggleSidebar()">
              <i class="bx bx-menu"></i>
            </div>
            <div class="position-relative search-bar d-lg-block d-none">
              <input
                class="form-control px-5"
                type="search"
                [placeholder]="'APPCOMPONENT.SEARCH.PLACEHOLDER' | translate"
                data-bs-toggle="modal"
                data-bs-target="#SearchModal"
                (click)="onInputChange()"
                readonly
              />
              <span
                class="position-absolute top-50 search-show ms-3 translate-middle-y start-0 top-50 fs-5"
                data-bs-toggle="modal"
                data-bs-target="#SearchModal"
                (click)="onInputChange()"
              >
                <i class="bx bx-search"></i>
              </span>
            </div>

            <div class="top-menu ms-auto">
              <ul class="navbar-nav align-items-center gap-1">
                <li
                  class="nav-item"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  <a
                    class="nav-link"
                    routerLink="/taskslist"
                    [title]="'COMMON.TASKS' | translate"
                  >
                    <i class="bi bi-check2-circle"></i>
                  </a>
                </li>

                <li
                  class="nav-item dark-mode"
                  [title]="
                    selectedTheme === 'dark-theme'
                      ? ('COMMON.LIGHT_MODE' | translate)
                      : ('COMMON.DARK_MODE' | translate)
                  "
                >
                  <a
                    class="nav-link dark-mode-icon"
                    href="javascript:void(0)"
                    (click)="
                      applyTheme();
                      $event.preventDefault();
                      $event.stopPropagation()
                    "
                  >
                    <i
                      [ngClass]="
                        selectedTheme === 'dark-theme'
                          ? 'bx bx-sun'
                          : 'bx bx-moon'
                      "
                    ></i>
                  </a>
                </li>
                <li
                  class="nav-item"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  <a
                    class="nav-link"
                    [title]="'COMMON.SUPPORT' | translate"
                    routerLink="/supportticketlist"
                  >
                    <i class="bx bx-support"></i>
                  </a>
                </li>

                <li>
                  <button
                    mat-icon-button
                    class="lang-btn"
                    [matMenuTriggerFor]="langMenu"
                    title="Switch Language"
                  >
                    <mat-icon>translate</mat-icon>
                  </button>
                  <mat-menu #langMenu="matMenu" xPosition="before">
                    <button
                      mat-menu-item
                      (click)="switchLanguage('en')"
                      [class.bg-light]="currentLang === 'en'"
                    >
                      <div
                        class="d-flex align-items-center justify-content-between w-100"
                      >
                        <div class="d-flex align-items-center">
                          <mat-icon class="me-3 text-secondary icon-compact"
                            >g_translate</mat-icon
                          >
                          <span [class.text-primary]="currentLang === 'en'"
                            >English</span
                          >
                        </div>
                        <mat-icon
                          *ngIf="currentLang === 'en'"
                          class="ms-4 text-primary"
                          >check</mat-icon
                        >
                      </div>
                    </button>

                    <button
                      mat-menu-item
                      (click)="switchLanguage('hi')"
                      [class.bg-light]="currentLang === 'hi'"
                    >
                      <div
                        class="d-flex align-items-center justify-content-between w-100"
                      >
                        <div class="d-flex align-items-center">
                          <mat-icon class="me-3 text-secondary icon-compact"
                            >auto_stories</mat-icon
                          >
                          <span [class.text-primary]="currentLang === 'hi'"
                            >Hindi</span
                          >
                        </div>
                        <mat-icon
                          *ngIf="currentLang === 'hi'"
                          class="ms-4 text-primary"
                          >check</mat-icon
                        >
                      </div>
                    </button>

                    <button
                      mat-menu-item
                      (click)="switchLanguage('gu')"
                      [class.bg-light]="currentLang === 'gu'"
                    >
                      <div
                        class="d-flex align-items-center justify-content-between w-100"
                      >
                        <div class="d-flex align-items-center">
                          <mat-icon class="me-3 text-secondary icon-compact"
                            >history_edu</mat-icon
                          >
                          <span [class.text-primary]="currentLang === 'gu'"
                            >Gujarati</span
                          >
                        </div>
                        <mat-icon
                          *ngIf="currentLang === 'gu'"
                          class="ms-4 text-primary"
                          >check</mat-icon
                        >
                      </div>
                    </button>

                    <button
                      mat-menu-item
                      (click)="switchLanguage('ja')"
                      [class.bg-light]="currentLang === 'ja'"
                    >
                      <div
                        class="d-flex align-items-center justify-content-between w-100"
                      >
                        <div class="d-flex align-items-center">
                          <mat-icon class="me-3 text-secondary icon-compact"
                            >temple_buddhist</mat-icon
                          >
                          <span [class.text-primary]="currentLang === 'ja'"
                            >Japanese</span
                          >
                        </div>
                        <mat-icon
                          *ngIf="currentLang === 'ja'"
                          class="ms-4 text-primary"
                          >check</mat-icon
                        >
                      </div>
                    </button>

                    <button
                      mat-menu-item
                      (click)="switchLanguage('fr')"
                      [class.bg-light]="currentLang === 'fr'"
                    >
                      <div
                        class="d-flex align-items-center justify-content-between w-100"
                      >
                        <div class="d-flex align-items-center">
                          <mat-icon class="me-3 text-secondary icon-compact"
                            >flag</mat-icon
                          >
                          <span [class.text-primary]="currentLang === 'fr'"
                            >French</span
                          >
                        </div>
                        <mat-icon
                          *ngIf="currentLang === 'fr'"
                          class="ms-4 text-primary"
                          >check</mat-icon
                        >
                      </div>
                    </button>

                    <button
                      mat-menu-item
                      (click)="switchLanguage('es')"
                      [class.bg-light]="currentLang === 'es'"
                    >
                      <div
                        class="d-flex align-items-center justify-content-between w-100"
                      >
                        <div class="d-flex align-items-center">
                          <mat-icon class="me-3 text-secondary icon-compact"
                            >explicit</mat-icon
                          >
                          <span [class.text-primary]="currentLang === 'es'">
                            Spanish
                          </span>
                        </div>
                        <mat-icon
                          *ngIf="currentLang === 'es'"
                          class="ms-4 text-primary"
                        >
                          check
                        </mat-icon>
                      </div>
                    </button>

                    <button
                      mat-menu-item
                      (click)="switchLanguage('ar')"
                      [class.bg-light]="currentLang === 'ar'"
                    >
                      <div
                        class="d-flex align-items-center justify-content-between w-100"
                      >
                        <div class="d-flex align-items-center">
                          <mat-icon class="me-3 text-secondary icon-compact"
                            >mosque</mat-icon
                          >
                          <span [class.text-primary]="currentLang === 'ar'"
                            >Arabic</span
                          >
                        </div>
                        <mat-icon
                          *ngIf="currentLang === 'ar'"
                          class="ms-4 text-primary"
                          >check</mat-icon
                        >
                      </div>
                    </button>
                  </mat-menu>
                </li>
              </ul>
            </div>
            <!-- Profile Section start -->
            <div class="user-box px-md-3 px-0">
              <a
                class="d-flex align-items-center nav-link gap-3 dropdown-toggle-nocaret"
                [matMenuTriggerFor]="profileMenu"
                style="cursor: pointer"
              >
                <img
                  src="{{ getDocThumbnail(userContext['imageId']) }}"
                  class="user-img"
                  alt="User"
                  (error)="
                    onImageError($event, 'assets/images/icons/user1.png')
                  "
                />
                <div class="user-info">
                  <p class="user-name mb-0">
                    {{ locator.userContext["name"] }}
                  </p>
                  <p class="designattion mb-0">
                    {{ locator.userContext["roleName"] }}
                  </p>
                </div>
              </a>
              <mat-menu #profileMenu="matMenu" class="custom-menu">
                <button
                  mat-menu-item
                  (click)="openLink('https://cuickdev.com/about-us.html')"
                >
                  <mat-icon class="text-secondary icon-compact">info</mat-icon>
                  <span>{{ "APPCOMPONENT.PROFILE.ABOUT_US" | translate }}</span>
                </button>
                <mat-divider></mat-divider>
                <button
                  mat-menu-item
                  (click)="openLink('https://cuickdev.com/pricing.html')"
                >
                  <mat-icon class="text-secondary icon-compact">sell</mat-icon>
                  <span>{{ "APPCOMPONENT.PROFILE.PLANS" | translate }}</span>
                </button>
                <mat-divider></mat-divider>
                <button mat-menu-item routerLink="users">
                  <mat-icon class="text-secondary icon-compact"
                    >account_circle</mat-icon
                  >
                  <span>{{ "APPCOMPONENT.PROFILE.PROFILE" | translate }}</span>
                </button>
                <mat-divider></mat-divider>
                <button mat-menu-item routerLink="organization">
                  <mat-icon class="text-secondary icon-compact"
                    >business</mat-icon
                  >
                  <span>{{
                    "APPCOMPONENT.PROFILE.ORGANIZATION" | translate
                  }}</span>
                </button>
                <mat-divider></mat-divider>
                <button mat-menu-item routerLink="login/logout">
                  <mat-icon class="text-secondary icon-compact"
                    >exit_to_app</mat-icon
                  >
                  <span>{{ "APPCOMPONENT.PROFILE.LOGOUT" | translate }}</span>
                </button>
              </mat-menu>
            </div>
          </nav>
        </div>
      </header>
      <!--end header -->

      <!--start page wrapper -->
      <div class="page-wrapper" *ngIf="isValidUser()">
        <div class="page-content">
          <div class="main-content">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
      <!--end page wrapper -->

      <!--start overlay-->
      <div class="overlay toggle-icon"></div>
      <!--end overlay-->

      <!--Start Back To Top Button-->
      <a href="javaScript:;" *ngIf="userContext?.name">
        <a
          href="javaScript:;"
          class="back-to-top"
          *ngIf="isBackToTopVisible"
          (click)="scrollToTop()"
        >
          <i class="bx bxs-up-arrow-alt"></i>
        </a>
      </a>
      <!--End Back To Top Button-->

      <!--start footer -->
      <footer class="page-footer" *ngIf="isValidUser()">
        <p class="mb-0">
          {{
            "APPCOMPONENT.FOOTER.COPYRIGHT" | translate: { year: currentYear }
          }}
        </p>
      </footer>
      <!--end footer -->
    </div>

    <router-outlet *ngIf="!isValidUser()"></router-outlet>

    <!-- Search Modal -->
    <div class="modal fade" id="SearchModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content border-0 shadow-lg rounded-4">
          <div class="modal-header border-bottom-0 p-4 pb-2 d-flex">
            <div class="position-relative popup-search w-100">
              <input
                class="form-control form-control-lg ps-5 border-primary"
                id="search-text"
                [(ngModel)]="searchText"
                (blur)="clearSearchOnBlur()"
                type="search"
                [placeholder]="'APPCOMPONENT.SEARCH.PLACEHOLDER' | translate"
                aria-describedby="search-text"
              />
              <span
                class="position-absolute top-50 search-show ms-3 translate-middle-y start-0 top-50 fs-4"
              >
                <i class="bx bx-search"></i>
              </span>
            </div>
            <button
              type="button"
              class="btn-close ms-3 align-self-center"
              data-bs-dismiss="modal"
            ></button>
          </div>

          <div class="modal-body p-4 pt-2">
            <p
              class="text-muted small fw-bold text-uppercase mb-3 ps-1"
              *ngIf="filteredMenuItems.length > 0"
            >
              {{ filteredMenuItems.length }} Menu Results Found
            </p>

            <div class="search-list">
              <div class="row g-2">
                <div class="col-12" *ngFor="let item of filteredMenuItems">
                  <a
                    [routerLink]="item.url"
                    class="search-result-item d-flex align-items-center p-3 rounded-3 text-decoration-none transition-all"
                    (click)="onItemClick()"
                  >
                    <div
                      class="search-icon-box rounded-circle bg-light d-flex align-items-center justify-content-center me-3"
                      style="width: 45px; height: 45px"
                    >
                      <i [class]="item.icon" class="fs-4 text-primary"></i>
                    </div>

                    <div class="flex-grow-1">
                      <h6 class="mb-0 fw-semibold text-dark">
                        {{ item.label | translate }}
                      </h6>
                    </div>

                    <i class="bx bx-chevron-right fs-4 text-muted ms-auto"></i>
                  </a>
                </div>

                <div
                  class="col-12 text-center py-5"
                  *ngIf="filteredMenuItems.length === 0"
                >
                  <div class="mb-3">
                    <i
                      class="bi bi-search text-light"
                      style="font-size: 5rem"
                    ></i>
                  </div>
                  <h5 class="text-secondary">No matches found</h5>
                  <p class="text-muted">
                    Try searching for "Dashboard", "Rules", or "App Store"
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div
            class="modal-footer border-top-1 bg-light p-2 justify-content-center rounded-bottom-4"
          >
            <button
              mat-stroked-button
              color="warn"
              data-bs-dismiss="modal"
              type="button"
            >
              <mat-icon class="icon-compact">close</mat-icon>
              {{ "COMMON.CLOSE" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- end search modal -->

    <app-theme-customizer *ngIf="isValidUser()"></app-theme-customizer>
  </div>
</div>

<div *ngIf="!showLayout">
  <router-outlet></router-outlet>
</div>